export default __webpack_public_path__ + "media/images/landing-11-550x420-0ca17189c7c63237b50ce754dd6c4295.jpg";